<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte';
    import TitleMenu from '../../../components/ui/menu/components/title-menu.svelte';
    import ModalChooseButton from '../../buttons/modal-choose-button.svelte';
    import CommonButton from '../../buttons/common-button.svelte';
    import { totalBet } from '@root/src/store/chips';
    import { trackEvent } from '../../../utils/init-analytics.js';
    import { get } from 'svelte/store';
    //exports
    export let autoPlayValues: number[];
    export let selectedValue: number;
    export let balance: string;
    export let selectedBetAmount: number;
    export let currency: string;

    const dispatch = createEventDispatcher();
    onMount(() => {
        trackEvent('click_autobet', {
            balance,
            currency
        });
    });

    const toggleSelectAutoPlayValue = newAutoPlayValue => {
        dispatch('change-auto-play-value', selectedValue === newAutoPlayValue ? null : newAutoPlayValue);

        if (selectedValue && selectedValue !== newAutoPlayValue) {
            trackEvent('change_autobet_counts', {
                balance,
                currency,
                bet_count: newAutoPlayValue
            });
        }
    };
</script>

<TitleMenu class="!mb-6 text-center !text-2xl tablet:!text-4xl">Autoplay</TitleMenu>

<section class="mx-auto flex max-w-[560px] flex-col gap-y-4">
    <h3 class="font-bold">Number of spins</h3>
    <div class="grid grid-cols-3 gap-2 desktop:gap-4">
        {#each autoPlayValues as autoPlayValue}
            <ModalChooseButton
                value={autoPlayValue}
                selectedValue={autoPlayValue === selectedValue}
                on:click={() => toggleSelectAutoPlayValue(autoPlayValue)}>{autoPlayValue}</ModalChooseButton
            >
        {/each}
    </div>
</section>

<div class="mt-8 flex justify-center">
    <CommonButton
        variants="primary"
        disabled={!selectedValue || parseFloat(balance) <  parseFloat(get(totalBet))}
        on:click={() => dispatch('start')}>START AUTOSPINS</CommonButton
    >
</div>
